import styled from 'styled-components';

import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

export const DrilldownItem = styled.a`
  position: relative;
  width: ${size(11)};

  & + & {
    margin-left: ${size(0.5)};
  }

  &:after {
    content: '';
    position: absolute;
    left: ${size(0.25)};
    top: ${size(-0.75)};
    border-radius: 50%;
    width: ${size(10.5)};
    height: ${size(10.5)};
    object-fit: cover;
    background: rgba(255, 255, 255, 0.15);
    opacity: 0;
    transition: opacity 100ms linear;

    ${theme.screens.Md} {
      width: ${size(16.5)};
      height: ${size(16.5)};
    }
  }

  ${theme.screens.Md} {
    width: ${size(17)};
    & + & {
      margin-left: ${size(1)};
    }
  }

  &:not(.active):hover {
    &:after {
      opacity: 1;
    }
  }

  &.active {
    cursor: default;

    &:after {
      opacity: 1;
      border: 2px solid rgba(0, 0, 0, 0.7);
      background: none;
    }
  }
`;

export const Drilldown = styled.div`
  display: inline-flex;
  padding: ${size(0.75)} 0;
`;

export const ItemImage = styled.img`
  display: block;
  margin: 0 ${size(1)} ${size(1)};
  border-radius: 50%;
  width: ${size(9)};
  height: ${size(9)};
  object-fit: cover;
  display: block;

  ${theme.screens.Md} {
    width: ${size(15)};
    height: ${size(15)};
    margin-bottom: ${size(2)};
  }
`;

export const ItemNoImage = styled.div`
  margin: 0 ${size(1)} ${size(1)};
  border-radius: 50%;
  width: ${size(9)};
  height: ${size(9)};
  background: ${theme.colors.bg.accent};

  ${theme.screens.Md} {
    margin-bottom: ${size(2)};
    width: ${size(15)};
    height: ${size(15)};
  }
`;

export const ItemLabel = styled.div`
  text-align: center;
  font-weight: ${theme.font.weight.medium};
  font-size: 0.75rem;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;

  ${theme.screens.Md} {
    font-size: 18px;
  }
`;
